import { CollapsibleSection } from "./CollapsibleSection.js";
import { WalletIntelPanel } from "./WalletIntelPanel.js";
import { FundingAttributionPanel } from "./FundingAttributionPanel.js";
import { ContractIntelPanel } from "./ContractIntelPanel.js";
import { ApprovalIntelPanel } from "./ApprovalIntelPanel.js";
import { LiquidityIntelPanel } from "./LiquidityIntelPanel.js";
import { LockerIntelPanel } from "./LockerIntelPanel.js";
import { HolderIntelPanel } from "./HolderIntelPanel.js";
import { SocialIntelPanel } from "./SocialIntelPanel.js";
import type { WalletIntelData } from "./WalletIntelPanel.js";
import type { FundingAttributionData } from "./FundingAttributionPanel.js";
import type { ContractIntelData } from "./ContractIntelPanel.js";
import type { ApprovalIntelData } from "./ApprovalIntelPanel.js";
import type { LiquidityIntelData } from "./LiquidityIntelPanel.js";
import type { LockerIntelData } from "./LockerIntelPanel.js";
import type { HolderIntelData } from "./HolderIntelPanel.js";
import type { SocialIntelData } from "./SocialIntelPanel.js";

export interface EliteIntelPanelProps {
  walletIntel?: WalletIntelData | null;
  fundingAttribution?: FundingAttributionData | null;
  contractIntel?: ContractIntelData | null;
  approvalIntel?: ApprovalIntelData | null;
  liquidityIntel?: LiquidityIntelData | null;
  lockerIntel?: LockerIntelData | null;
  holderIntel?: HolderIntelData | null;
  socialIntel?: SocialIntelData | null;
}

export function EliteIntelPanel({
  walletIntel,
  fundingAttribution,
  contractIntel,
  approvalIntel,
  liquidityIntel,
  lockerIntel,
  holderIntel,
  socialIntel,
}: EliteIntelPanelProps) {
  return (
    <div className="intel-section-group">
      <h2 className="intel-section-header">Detailed Intelligence</h2>
      <p className="intel-section-desc">Expand each section for in-depth forensic analysis.</p>
      <div className="intel-elite-sections">
        <CollapsibleSection title="Creator & Wallet Intelligence">
          <WalletIntelPanel data={walletIntel ?? null} />
          <FundingAttributionPanel data={fundingAttribution ?? null} />
        </CollapsibleSection>

        <CollapsibleSection title="Contract Risk Assessment">
          <ContractIntelPanel data={contractIntel ?? null} />
          <ApprovalIntelPanel data={approvalIntel ?? null} />
        </CollapsibleSection>

        <CollapsibleSection title="Liquidity & Exit Risk">
          <LiquidityIntelPanel data={liquidityIntel ?? null} />
          <LockerIntelPanel data={lockerIntel ?? null} />
        </CollapsibleSection>

        <CollapsibleSection title="Holder Distribution">
          <HolderIntelPanel data={holderIntel ?? null} />
        </CollapsibleSection>

        <CollapsibleSection title="Social & Reputation">
          <SocialIntelPanel data={socialIntel ?? null} />
        </CollapsibleSection>
      </div>
    </div>
  );
}
